import { Switch } from 'sonata-react-components';

import { usePOIImporter } from '@/components/common/POIImporter/POIImporter.context';
import { AttributionPOIModal } from './AttributionPOIModal/AttributionPOIModal';
import { AttributionPOISelection } from './AttributionSelection/AttributionPOISelection';

import type { AttributionSubsection } from '../../multiFlightMap.types';

export function AttributionPOI() {
  const { attributionMode, importMode, isModalShowed } = usePOIImporter();

  const attributionSubsection: AttributionSubsection =
    attributionMode === 'attributionPOI' ? 'attributionPOIs' : 'proximityPoints';

  return (
    <Switch>
      <Switch.Case condition={!isModalShowed}>{null}</Switch.Case>
      <Switch.Case condition={!importMode}>
        <AttributionPOISelection attributionSubsection={attributionSubsection} />
      </Switch.Case>
      <Switch.Case condition={Boolean(importMode)}>
        <AttributionPOIModal />
      </Switch.Case>
      <Switch.Default>Not match found</Switch.Default>
    </Switch>
  );
}
